<template>
  <div>
    <div class="backed" v-if="formData.outlayStatus == 2 || formData.outlayStatus == 3">
      <img src="/static/err-icon.png" alt="" />
      <span v-if="formData.outlayStatus == 2" class="back-title">退回原因：</span>
      <span v-if="formData.outlayStatus == 3" class="back-title">放弃原因：</span>
      <span class="back-msg">{{ formData.apprOpinion }}</span>
    </div>
    <dialogPanel>
      <ChapterHead>
        <span v-if="addAngleStages">费用信息</span>
        <span v-else>
          <span>费用编号：{{formData.outlayId}}</span>
          <span v-if="formData.belongProject != 'AY1002'" style="margin-left: 20px;">
            资助限额：{{(formData.helpQuota || 0) + (formData.specialQuota || 0)}}元
          </span>
          <span v-if="formData.belongProject != 'AY1002' && formData.specialQuota" style="margin-left: 20px;">
            <img src="/static/err-icon.png" style="width: 14px;" />
            <span style="font-size: 14px;">救助限额说明：救助限额 {{formData.helpQuota || 0}} 元 + 特患资助 {{formData.specialQuota || 0}} 元</span>
          </span>
        </span>
        <span slot="extra">
          <img src="/static/status-icon.png" style="width: 15px;height: 15px;margin-right: 6px;vertical-align: middle;" alt="">
          <span v-if="formData.outlayStatus == 0" style="vertical-align: middle;">待提交</span>
          <span v-else style="vertical-align: middle;">{{formData.outlayStatusName}}</span>
          <!-- <el-button type="primary" v-if="['todo', 'timeout'].indexOf(localActive) > -1 && [0, 2].indexOf(formData.outlayStatus) > -1" icon="el-icon-success" size="mini" @click="giveUpData">放弃</el-button> -->
          <!-- <el-button :loading="loading" type="primary" v-if="!localReadOnly" icon="el-icon-s-release" size="mini" @click="saveData">暂存</el-button>
          <el-button :loading="loading" type="primary" v-if="!localReadOnly" icon="el-icon-success" size="mini" @click="submitData">提交</el-button>
          <el-button :loading="loading" type="primary" v-if="!localReadOnly" icon="el-icon-close" size="mini" @click="closeDetail">关闭</el-button> -->
        </span>
      </ChapterHead>
      <div class="screen" style="margin-top: 20px;">
        <CureOutlayTsForm
          v-if="belongProject == 'AY1002'"
          ref="tsForm"
          :outlayId="outlayId"
          :helpReqId="helpReqId"
          :addAngleStages="addAngleStages"
          :readOnly="localReadOnly"
          @onload="formOnLoad"
          @beforeSave="beforeSave"
          @complete="formSaveComplete"
          @success="formSaveSuccess">
        </CureOutlayTsForm>
        <CureOutlayTxCxForm
          v-if="belongProject == 'AY1001' || belongProject == 'AY1003'"
          ref="txcxForm"
          :outlayId="outlayId"
          :helpReqId="helpReqId"
          :readOnly="localReadOnly"
          @onload="formOnLoad"
          @beforeSave="beforeSave"
          @complete="formSaveComplete"
          @success="formSaveSuccess">
        </CureOutlayTxCxForm>
      </div>
    </dialogPanel>
    <el-collapse :value="['1', '2', '3']" >
      <MyCollapse v-if="showCase"  title="病历信息"  iconPath="/static/de-zmr.png"  name="1">
        <ChildCase :helpReqId="formData.helpReqId" :helpId="formData.helpId" :belongProject="belongProject" :dataMode="'detail'"></ChildCase>
      </MyCollapse>
      <MyCollapse v-if="localReadOnly" title="辅助信息"  iconPath="/static/de-zmr.png"  name="2">
        <OutlayOtherInfo :formData="formData"></OutlayOtherInfo>
      </MyCollapse>
    </el-collapse>
    <OutlayGiveUpDialog v-if="giveUpVisible" :outlayId="formData.outlayId" :visible="giveUpVisible" @success="formSaveSuccess" @close="giveUpVisible = false"></OutlayGiveUpDialog>
  </div>
</template>

<script>
import ChapterHead from "@/components/business/ChapterHead";
import CureOutlayTsForm from "./CureOutlayTsForm";
import CureOutlayTxCxForm from "./CureOutlayTxCxForm";
import ChildCase from "@/pages/child/view/ChildCase";
import dialogPanel from "@/components/business/dialogPanel";
import MyCollapse from "@/components/business/MyCollapse";
import OutlayOtherInfo from '../view/OutlayOtherInfo'
import OutlayGiveUpDialog from './OutlayGiveUpDialog'

export default {
  components: {
    ChapterHead,
    CureOutlayTxCxForm,
    CureOutlayTsForm,
    ChildCase,
    dialogPanel,
    MyCollapse,
    OutlayOtherInfo,
    OutlayGiveUpDialog
  },
  props: {
    active: String,
    outlayId: String,
    belongProject: String,
    readOnly: false,
    showCase: {
      type: Boolean,
      default: true
    },
    addAngleStages: {
      type: Boolean,
      default: false
    },
    helpReqId: String
  },
  data() {
    return {
      loading: false,
      localReadOnly: true,
      localActive: this.active,
      giveUpVisible: false,
      formData: {},
      helpRequestData: {}
    };
  },
  watch: {
    active (val) {
      this.localActive = val;
    }
  },
  methods: {
    formOnLoad (formData) {
      this.formData = formData;
      // this.localReadOnly = this.readOnly || this.formData.outlayStatus != 0;
    },
    saveData () {
      if (this.belongProject == 'AY1002') {
        this.$refs.tsForm.saveData();
      } else {
        this.$refs.txcxForm.saveData();
      }
    },
    submitData () {
      if (this.belongProject == 'AY1002') {
        this.$refs.tsForm.submitData();
      } else {
        this.$refs.txcxForm.submitData();
      }
    },
    giveUpData () {
      this.giveUpVisible = true;
    },
    formSaveComplete () {
      this.loading = false;
      this.$emit('saveComplete');
    },
    beforeSave () {
      this.$emit('beforeSave');
    },
    formSaveSuccess () {
      this.$emit('success')
    },
    closeDetail () {
      this.$emit('close')
    }
  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
@import "src/common/dialog.scss";
</style>



// WEBPACK FOOTER //
// src/pages/outlay/view/CureOutlayDetail.vue